import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

type Props = {
  edge: 'top' | 'bottom';
  color?: string;
  height?: number;
  sx?: SxProps<Theme>;
};

/** A decorative overlay: scrolling and controls underneath remain interactive. */
export default function ScrollEdgeFade({ edge, color = '#101219', height = 38, sx }: Props) {
  return (
    <Box
      aria-hidden="true"
      data-scroll-fade={edge}
      sx={[
        {
          position: 'absolute',
          left: 0,
          right: 0,
          [edge]: 0,
          height,
          zIndex: 3,
          pointerEvents: 'none',
          background: `linear-gradient(${edge === 'top' ? '180deg' : '0deg'}, ${color} 8%, transparent 100%)`,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
}
